/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Button, Grid, Skeleton, Typography, useMediaQuery, useTheme } from "@mui/material";
import { CustomCheckList } from "@components/CustomCheckList/CustomCheckList";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "@store/store";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { InactivityHandler } from "@components/InactivityHandler";
import { setModalErrorVisible } from "@store/slices/appSlice";
import { ApiError } from "@interfaces/response";
import CustomRightImage from "@components/CustomRightImagev2";
import { usePostValidateNextStageMutation } from "@api/applications";
import { TAX_SYSTEM_TYPE, VISUAL_CONFIG_CODES } from "@helpers/constantes";
import { useLazyGetVisualConfigQuery } from "@api/configuration";
import { ChecklistSectionDocuments, GuaranteeType } from "@interfaces/catalogs";
import { useLazyGetGuaranteeTypeQuery } from "@api/catalogs";
import { filterChecklistByGuarantee } from "@components/CustomCheckList/functions";
import { DEFAULT_CHECKLIST_EXPEDIENTE_PF, DEFAULT_CHECKLIST_EXPEDIENTE_PFAE } from "@helpers/visualConfig";
import useStatusConfig from "@hooks/useStatusConfig";

const SCREEN_STATUS = "CSBEX";

const InfoDocumentosPFAE = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const { nextStatus } = useStatusConfig(SCREEN_STATUS);

  const application = useSelector((state: RootState) => state.register.application);
  const personalData = useSelector((state: RootState) => state.register.personal_data);
  const accountUser = useSelector((state: RootState) => state.register.account_user);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [triggerPostNextStage] = usePostValidateNextStageMutation();
  const [getVisualConfig] = useLazyGetVisualConfigQuery();
  const [getGuaranteeType] = useLazyGetGuaranteeTypeQuery();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [checklist, setChecklist] = useState<ChecklistSectionDocuments>([]);
  const [loadingChecklist, setLoadingChecklist] = useState<boolean>(false);

  const handleOnClickNext = async () => {
    try {
      setIsLoading(true);

      if (!nextStatus) {
        throw new Error("Next status is required");
      }

      await triggerPostNextStage({
        applicationId: application.id,
        statusCode: nextStatus?.code,
        username: `BOFU - ${accountUser.email}`,
      }).unwrap();

      navigate(nextStatus?.url);
    } catch (error) {
      dispatch(setModalErrorVisible({ open: true, error: error as ApiError }));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (application.tax_system_type === TAX_SYSTEM_TYPE.PF.code) {
      setChecklist(DEFAULT_CHECKLIST_EXPEDIENTE_PF);
    } else {
      setChecklist(DEFAULT_CHECKLIST_EXPEDIENTE_PFAE);
    }
  }, [application]);

  useEffect(() => {
    (async () => {
      try {
        if (!application.tax_system_id) {
          return;
        }

        setLoadingChecklist(true);

        // obtener los tipos de garantia y los documentos de la configuracion
        const [guarantees, checklist] = await Promise.all([
          getGuaranteeType().unwrap(),
          getVisualConfig({
            tax_system_id: application.tax_system_id,
            code: VISUAL_CONFIG_CODES.CHECKLIST_EXPEDIENTE,
          }).unwrap(),
        ]);

        console.log(typeof checklist);

        if (checklist && checklist.length) {
          // identificar el tipo de garantia, en caso de ser necesario
          const guarantee_type: GuaranteeType | undefined = application.guarantee_type_id
            ? guarantees.find((item) => item.id === application.guarantee_type_id)
            : undefined;

          // filtar por garantia
          const filtered_checklist = filterChecklistByGuarantee(checklist as ChecklistSectionDocuments, guarantee_type);
          // ordenar por orden
          filtered_checklist.sort((a, b) => (a.order || 0) - (b.order || 0));
          setChecklist(filtered_checklist);
        }
      } catch (error) {
        console.log("Ha ocurrido un error", error);
      } finally {
        setLoadingChecklist(false);
      }
    })();
  }, []);

  return (
    <Grid container height="100%">
      <Grid item xs={12} md={8}>
        <InactivityHandler />
        <Box textAlign={"center"} mx={4}>
          <Typography
            mt={4}
            mb={3}
            textAlign={"center"}
            variant={isMobileOrTablet ? "h4" : "h3"}
            fontWeight={600}
            color={theme?.palette?.primary?.dark}
          >
            ¡Hola {personalData.name}!
          </Typography>
          <Typography
            mb={3}
            textAlign={"center"}
            variant={isMobileOrTablet ? "body2" : "body1"}
            color={theme?.palette?.primary?.main}
            fontWeight={600}
          >
            Ahora completa el expediente digital.
          </Typography>
          <Typography
            mb={3}
            textAlign={"center"}
            variant={isMobileOrTablet ? "body2" : "body1"}
            color={theme?.palette?.primary?.dark}
          >
            Conforme avances, deberás cargar los siguientes documentos, si no los tienes a la mano puedes guardar tu
            avance y completarlo después
          </Typography>
          {loadingChecklist ? (
            <Skeleton variant="rectangular" sx={{ height: "200px", width: "100%", borderRadius: 2, my: 3 }} />
          ) : (
            <>
              <Box display={"flex"} flexDirection={"column"} gap={2} my={3}>
                {checklist.map((item) => (
                  <CustomCheckList
                    key={item.title}
                    id={item.title}
                    title={item.title}
                    tooltip={item.tooltip}
                    items={item.documents}
                  />
                ))}
              </Box>
              <Button variant="default" onClick={handleOnClickNext} disabled={isLoading}>
                Continuar
              </Button>
            </>
          )}
        </Box>
      </Grid>
      {isMobileOrTablet == false && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default InfoDocumentosPFAE;
